import server from './base';

//
const { NEW_SHINE_BASE_URL } = server;
export default {
  // 活动信息
  '/shop-product-list/getActivity': {
    method: 'POST',
    action: '/api/fe/shop-product-list/getActivity',
    baseURL: NEW_SHINE_BASE_URL
  }
};
